import { api } from "src/services/api";

export const setAuthToken = () => {
	const token = localStorage.getItem("@stricv2:token");

	api.defaults.headers.common.Authorization = `Bearer ${token}`;
};
